import { Panel, Table } from '@/components/Bicester';
import { PopoverWrapper } from '@/components/Bicester/PopoverWrapper';
import { Cell } from '@/components/Bicester/Table';
import { DateTimeCell } from '@/components/Bicester/Table/Cells';
import { BICESTER_FULL_DATE_TIME } from '@/constants/dateFormat';
import useRouter from '@/hooks/useRouter';
import useTable from '@/hooks/useTable';
import { fetchMemberLogList } from '@/services/account';
import { useRequest } from 'ahooks';
import React from 'react';

const ModifyLog = () => {
  const { match, query } = useRouter<{ id: string }>();

  const {
    run: getMemberLogList,
    data: { content_list: recordListData, current_page, total } = {},
    loading: recordListLoading,
  } = useRequest(fetchMemberLogList, {
    manual: true,
  });

  const { onChange, onSearch } = useTable(async (p) => {
    const params = Object.assign({}, p, {
      member_id: match.params.id,
    });
    await getMemberLogList(params);
  });

  return (
    <Panel
      title="会员信息操作日志"
      expanded
      defaultExpand={false}
      onExpand={(expanded) =>
        expanded &&
        !recordListData?.length &&
        getMemberLogList({ page: 1, member_id: match.params.id })
      }
      subTitle={`总计 ${total || 0} 条`}
    >
      <Table
        pageInfo={{ page: current_page, total }}
        data={recordListData ?? []}
        loading={recordListLoading}
        columns={[
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '操作时间',
            cell: <DateTimeCell dataKey="create_at" format={BICESTER_FULL_DATE_TIME} />,
          },
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '操作人',
            cell: <Cell dataKey="name" />,
          },
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '操作内容',
            cell: (
              <Cell dataKey="content">
                {(rowData) => (
                  <PopoverWrapper popover={{ content: rowData?.content }}>
                    <div className="rs-table-cell-content px-0">{rowData?.content}</div>
                  </PopoverWrapper>
                )}
              </Cell>
            ),
          },
        ]}
        onChange={onChange}
      >
        <Table.Body isEmptyHoverBody={false} />
        <Table.Pagination />
      </Table>
    </Panel>
  );
};

export default ModifyLog;
